/* unplugin-vue-components disabled */import { render } from "./AIQuizGenerationDocumentUpload.vue?vue&type=template&id=1432a849&scoped=true&ts=true"
import script from "./AIQuizGenerationDocumentUpload.vue?vue&type=script&lang=ts"
export * from "./AIQuizGenerationDocumentUpload.vue?vue&type=script&lang=ts"

import "./AIQuizGenerationDocumentUpload.vue?vue&type=style&index=0&id=1432a849&lang=scss&scoped=true"
import "./AIQuizGenerationDocumentUpload.vue?vue&type=style&index=1&id=1432a849&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1432a849"]])

export default __exports__